import React, { useEffect, useState } from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
  faLinkedinIn,
  faXTwitter,
  faYoutube,
  faYoutubeSquare,
} from "@fortawesome/free-brands-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  AllBrand,
  Brandings,
  getAllCategories,
} from "../../features/master/masterSlice";
import Book_appointment_modal from "../common-components/common-modals/book-appointment-modal/Book_appointment_modal";
import { getSocialmedia } from "../../features/socialmedia/Slice";
import CryptoJS from "crypto-js";
const SECRET_KEY = "my_secret_key_123";
const Footer = ({ handleFilterChange }) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.master.categories);
  const brand = useSelector((state) => state.master.all_brands);
  const [modalShow, setModalShow] = React.useState(false);

  const medias = useSelector((state) => state.socialmedia.addSocialmedia);

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(AllBrand());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getSocialmedia());
  }, []);

  const Support = [
    { label: "Shipping", link: "/shipping-policy" },
    // { label: "Return", link: "" },
    { label: "Terms & Condition", link: "/terms-conditions" },
    { label: "Refund Policy", link: "/refund-policy" },
    { label: "Privacy Policy", link: "/privacy" },
  ];

  const QuickLinks = [
    { label: "What's new", link: "" },
    { label: "EyeQ", link: "/eye-q" },
    { label: "Bapat benefits", link: "/bapat-benefits" },
    { label: "Quick quiz", link: "/quick-quiz" },
    { label: "Refer a friend", link: "/bapat-benefits" },
    { label: "FAQ", link: "" },
  ];

  const About = [
    { label: "About us", link: "/bapat-benefits" },
    { label: "Contact us", link: "/contact-us" },
    { label: "Career", link: "" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = async (filter, value) => {
    await handleFilterChange(filter, value);
    window.scrollTo(0, 0);
  };

  const [randomBrands, setRandomBrands] = useState([]);

  useEffect(() => {
    if (!brand || brand.length === 0) return;

    const shuffleBrands = () => {
      const shuffled = [...brand]
        .sort(() => 0.5 - Math.random()) // random order
        .slice(0, 10); // show only 10
      setRandomBrands(shuffled);
    };

    // shuffle immediately
    shuffleBrands();

    // shuffle every 10 seconds (10000 ms)
    const interval = setInterval(shuffleBrands, 10000);

    // cleanup on unmount
    return () => clearInterval(interval);
  }, [brand]);

  const navigate = useNavigate();

  // Function to encrypt gender object
  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };
  const handleCategory = (gender) => {
    console.log(gender, "gender gender gender");

    const token = encryptData(gender);
    navigate(`/all-products?category=${encodeURIComponent(token)}`);

    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="content_div">
            <div className="row">
              <div className="col-lg-3 col-md-12 mb-2 p-1">
                <div className="company_info_div">
                  <div className="logo_holder">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/footer/logo.png"
                      }
                      className="logo"
                    />
                  </div>
                  <p className="info_text">
                    Great vision starts with great design stylish, comfortable
                    eyewear by <b>bapat optics</b>
                  </p>

                  {/* <div className="location_div">
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={faLocationDot} className="icon" />
                    </div>
                    <p className="location_text">
                      Find the <br /> Nearest store
                    </p>
                  </div> */}
                </div>
              </div>

              <div className="col-lg-8 col-md-12 mb-2 ">
                <div className="row">
                  <div className="col-sm-2 col-6 p-1 mobile_div">
                    <div className="link_div ">
                      <h3 className="heading_text">Brands</h3>

                      <ul>
                        {randomBrands?.slice(0, 6).map((item) => {
                          return (
                            <li key={item?.id}>
                              <Link
                                className="link_text"
                                to={"/all-products"}
                                onClick={() => {
                                  handleClick("brands", {
                                    id: item?.id,
                                    name: item?.name,
                                  });
                                }}
                              >
                                {item?.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-2  col-12 p-1">
                    <div className="link_div">
                      <h3 className="heading_text">Collection</h3>

                      <ul className="about_ul">
                        {categories?.map((item) => {
                          return (
                            <li
                              className="link_text"
                              onClick={() =>
                                handleCategory({
                                  id: item?.id,
                                  name: item?.name,
                                })
                              }
                            >
                              {/* <Link
                                className="link_text"
                                to={"/all-products"}
                                onClick={() => {
                                  handleClick("category", {
                                    id: item?.id,
                                    name: item?.name,
                                  });
                                }}
                              > */}
                              {item?.name}
                              {/* </Link> */}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-2  col-12 p-1">
                    <div className="link_div">
                      <h3 className="heading_text">Support</h3>

                      <ul className="about_ul">
                        {Support?.map((item) => {
                          return (
                            <li>
                              <Link className="link_text" to={item?.link}>
                                {item?.label}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className="col-sm-2 col-6 p-1 mobile_div">
                    <div className="link_div">
                      <h3 className="heading_text">Quick links</h3>

                      <ul>
                        {QuickLinks?.map((item) => {
                          return (
                            <li>
                              <Link className="link_text" to={item?.link}>
                                {item?.label}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-2 col-12 p-1">
                    <div className="link_div">
                      <h3 className="heading_text">About</h3>

                      <ul className="about_ul">
                        {About?.map((item) => {
                          return (
                            <li>
                              <Link
                                className="link_text"
                                to={`${item.link}`}
                                onClick={() => {
                                  if (item.label === "Career") {
                                    setModalShow(true);
                                  }
                                }}
                              >
                                {item?.label}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-2 col-4 p-1">
                    <div className="all_icons_holder">
                      {medias?.map((data, index) => {
                        const fullUrl =
                          data.url.startsWith("http://") ||
                          data.url.startsWith("https://")
                            ? data.url
                            : `https://${data.url}`;
                        return (
                          <Link key={index} to={fullUrl} target="_blank">
                            <div className="social_icon_holder">
                              <img
                                src={
                                  process.env.REACT_APP_IMAGE_URL + data.image
                                }
                                className="social_icon"
                                alt={data.name}
                              />
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="copyrightdiv">
              <p className="cppp">
                © 2025 Bapat Optics. All Rights Reserved. Developed by{" "}
                <Link target="_blank" to="https://profcymaglobal.com/">
                  Profcyma
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className="mobile_logo_holder">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/footer/logo.png"}
            className="logo"
          />
        </div>
      </section>
      <Book_appointment_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Footer;
